import { render } from "./payment-settings.vue?vue&type=template&id=250f004b"
import script from "./payment-settings.vue?vue&type=script&lang=js"
export * from "./payment-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__